import React from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import EventForm from "./EventForm";

const Page = ({ editing }) => {
  const navigate = useNavigate();
  const params = useParams();
  const eventId = params?.id;

  return (
    <div className="right-nav" id="dash-event">
      <div className="modal-content">
        <div className="modal-header">
          <h4 className="modal-title">{editing ? "Edit" : "Add"} Event / Test</h4>
          <Link to="/branch/events/all" className="edit-btn">
            <i className="fa fa-arrow-left"></i>
          </Link>
        </div>
        <div className="modal-body">
          <EventForm
            editing={editing}
            eventId={eventId}
            onSaved={() => navigate("/branch/events/all")}
          />
        </div>
      </div>
    </div>
  );
};

export const AddEvent = () => <Page editing={false} />;
export const EditEvent = () => <Page editing={true} />;
